<template>
<el-popover ref="predictPopover" popper-class="event-popover" placement="bottom" width="400" trigger="click" @show="onEventPopoverShow" @hide="onPredictEventPopoverHide">
  <!-- reference -->
  <el-badge slot="reference" ref="eventBadge" class="tool-icon event-badge c-pointer"  :value="eventTotalCount" :max="99"> <!-- :hidden="eventTotalCount <= 0"-->
    <el-tooltip content="사전 예측 이벤트" placement="bottom">
      <i class="fas fa-clock r-top"></i>
    </el-tooltip>
  </el-badge>
  <!-- <span slot="reference"><slot name="button"></slot></span> -->
  <!-- popover -->
  <div>
    <el-row type="flex" class="title-bar" justify="space-between">
      <div class="mr-l15 title-h4">사전 예측 이벤트</div>
    </el-row>
    <div class="content" v-loading="isLoading">
      <el-scrollbar class="bar-visible">
        <ul class="event-notice">
          <li v-for="(item, index) in eventDatas" :key="index">
            <span class="icon-dot" :style="{ backgroundColor: item.eventlevelColorBg }"></span>
            <span class="text-area">
                <div class="desc">
                  {{ item.objName }}
                </div>
                <div class="c-pointer" @click="onClickEventRow(item)">{{item.eventMessage }}</div>
                <span class="date">{{ convertDatetime(item.checkDatetime) }}</span>
            </span>
          </li>
        </ul>
      </el-scrollbar>
    </div>
  </div>
  <el-row class="footer" type="flex" justify="space-between">
    <el-checkbox-group v-model="checkedEventlevelIds" @change="onChangeEventId">
      <el-checkbox style="min-width:52px;" v-for="item in eventCountDatas" :key="item.eventlevelId" :label="item.eventlevelId">
        <div class="label">
          <div :class="$style['event-level-dot']" :style="{ backgroundColor: item.eventlevelColorBg }"></div>
          {{ item.cnt }}
        </div>
      </el-checkbox>
    </el-checkbox-group>
    <!-- <el-button type="solid" @click="onClickClearStore"> 초기화 </el-button> -->
  </el-row>
</el-popover>
</template>

<script>
import { isNil, isEmpty, forEach } from 'lodash';
import eventAPI from '@/api/frame/event';
import { routePathByObjEventHist } from '@/utils/router';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import { mapGetters } from 'vuex';

export default {
  name: 'WPredictEventPopover',
  data() {
    return {
      isLoading: false,
      checkedEventlevelIds: [],
      eventDatas: [],
      eventCountDatas: [],
      currentHighEventlevel: null,
      eventTotalCount: 0,
      eventPredictCountTask: 'eventPredictCountTask',
    };
  },
  computed: mapGetters(['selectedNode']),
  created() {
    this.loadPredictEventCount(true);
    this.$taskManager.createTask(this.eventPredictCountTask, 30, this.loadPredictEventCount, true);
    this.$taskManager.startTask(this.eventPredictCountTask);
  },
  beforeDestroy() {
    this.$taskManager.removeTask(this.eventPredictCountTask);
  },
  methods: {
    loadEventStatus() {
      this.isLoading = true;
      eventAPI.getPredictEventList({ eventIdList: this.checkedEventlevelIds }).then((response) => {
        if (response.data.success) {
          this.eventDatas = response.data.data;
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    onEventPopoverShow() {
      this.$nextTick(() => {
        this.loadPredictEventCount();
        this.loadEventStatus();
      });
    },
    onPredictEventPopoverHide() {
      this.eventDatas = [];
    },
    /**
     * 사전 예측 이벤트 갯수를 조회한다.
     * @author yelim
     */
    loadPredictEventCount(setEventlevelCheckboxFlag) {
      eventAPI.getPredictEventCount().then((response) => {
        if (response.data.success) {
          this.eventCountDatas = response.data.data;
          this.setCurrentHighEventlevelAndTotalCount(this.eventCountDatas);
          if (setEventlevelCheckboxFlag) {
            const eventlevelIds = [];
            forEach(this.eventCountDatas, (item) => {
              eventlevelIds.push(item.eventlevelId);
            });
            this.checkedEventlevelIds = eventlevelIds;
          }
        }
      });
    },
    /**
     * 가장 높은 등급의 이벤트 등급 색상을 설정한다.
     * @author yelim
     */
    setCurrentHighEventlevelAndTotalCount(eventlevelCounts) {
      let highEventlevel = null;
      let total = 0;
      for (let i = 0; i < eventlevelCounts.length; i += 1) {
        if (highEventlevel === null && eventlevelCounts[i].cnt > 0) {
          highEventlevel = eventlevelCounts[i];
        }
        total += eventlevelCounts[i].cnt;
      }

      if (this.eventTotalCount !== total) {
        this.$emit('count-change', total);
      }

      this.eventTotalCount = total;
      this.currentHighEventlevel = highEventlevel;
      const badgeContentEl = isNil(this.$refs.eventBadge) ? null : this.$refs.eventBadge.$el.querySelector('.el-badge__content');
      if (!isNil(highEventlevel) && !isNil(badgeContentEl)) {
        badgeContentEl.style.backgroundColor = highEventlevel.eventlevelColorBg;
      }
      this.$emit('totalPredictEvent', total);
    },
    /**
     * 체크된 이벤트 레벨 아이디를 기준으로 데이터를 로드한다.
     * @author yelim
     */
    onChangeEventId() {
      if (this.checkedEventlevelIds.length === 0) {
        this.eventDatas = [];
      } else {
        this.loadEventStatus();
      }
    },
    convertDatetime(value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return getDateToString(value);
    },
    /**
     * 선택한 대상의 이벤트 탭으로 이동한다.
     * @author yelim
     */
    onClickEventRow(row) {
      if (!isNil(row.objId)) {
        this.$refs.predictPopover.showPopper = false;
        routePathByObjEventHist(this, row.objId, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, row.checkDatetime);
      }
    },
  },
};
</script>

<style module>
.event-level-dot {
  display: inline-block;
  height: 9px;
  width: 9px;
  position: relative;
  top: 1px;
  border-radius: 50%;
  margin-left: 2px;
}

.txt {
  display: flex;
  align-items: center;
  margin-top: 0.5px;
  color: #666;
  line-height: initial;
}
</style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/PredictEventPopover.vue